import { useState } from 'react';
import StatusSelect from './Selects/StatusSelect';
import ScopeSelect from './Selects/ScopeSelect';
import EntitySelect from './Selects/EntitySelect';
import RoleSearchBar from './RoleSearchBar';
import { Grid, Button } from '@mui/material';
import SearchButton from 'components/common/SearchButton';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router';
import intl from 'components/i18n/ReactIntlWrapper';

const RoleNavbar = ({ entities, status, scopes, onSearch, input }) => {
    
    const [queryString, setQueryString] = useState<string>('');
    const [idScope, setIdScope] = useState<string>(null);
    const [entityId, setEntityId] = useState<string>(null);
    const [entityTypeId, setEntityTypeId] = useState<string>(null);
    const [idStatus, setIdStatus] = useState<string>(null);
    const navigate = useNavigate();

    const handleSearchButton = () => {
        onSearch(queryString, idScope, entityId, entityTypeId, idStatus);
    };

    const handleScopeChange = (e, v) => {
        if (v !== null) {
            setIdScope(v.id);
        } else {
            setIdScope(null);
        }
    };

    const handleEntityChange = (e, v) => {
        if (v !== null) {
            setEntityId(v.id);
            setEntityTypeId(v.typeId);
        } else {
            setEntityId(null);
            setEntityTypeId(null);
        }
    };

    const handleStatusChange = (e, v) => {
        if (v !== null) {
            setIdStatus(v.active);
        } else {
            setIdStatus(null);
        }
    };

    return (
        <>
            <Grid container spacing={1}>
                    <Grid
                        size={{
                            md: "grow"
                        }}>
                    <RoleSearchBar queryString={queryString} setQueryString={setQueryString}/>
                    </Grid>
                    <Grid
                        size={{
                            md: 2
                        }}>
                    <ScopeSelect scopes={scopes} handleScopeChange={handleScopeChange} selectedScope={idScope}/>
                    </Grid>
                    <Grid
                        size={{
                            md: 2
                        }}>
                    <EntitySelect entities={entities} handleEntityChange={handleEntityChange} selectedEntity={entityId} selectedEntityType={entityTypeId} disabled={false} input={input} idNumber={null}/>
                    </Grid>
                    <Grid
                        size={{
                            md: 2
                        }}>
                    <StatusSelect status={status} handleStatusChange={handleStatusChange} selectedStatus={idStatus} disabled={false} defaultValue={false} isClearable={true}/>
                    </Grid>
                    <Grid
                        size={{
                            md: 2
                        }}>
                        <SearchButton clickEvent={handleSearchButton} />
                    </Grid>
                    <Grid size="auto">
                        <Button onClick={() => navigate(`/role/new`)}>
      		                <AddIcon /> {intl.get('role.new') ? intl.get('role.new') : intl.get('button.new')}
      		            </Button>
                    </Grid>
            </Grid>
        </>
    );
}

export default RoleNavbar;